// extracted by mini-css-extract-plugin
export var sectionFriends = "SectionFriends-module--sectionFriends--TbXhY";
export var sectionTitle = "SectionFriends-module--sectionTitle--h+cZZ";